const noMask = {
  guide: false,
  showMask: false,
  mask: false
};

const numberMask = {
  guide: false,
  showMask: false,
  mask: [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/,/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
};

const liquidationMask = {
  guide: false,
  showMask: false,
  mask: [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
};

const cnpjMask = {
  guide: false,
  showMask: false,
  mask: [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
};

const cpfMask = {
  guide: false,
  showMask: false,
  mask: [/\d/ , /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/ , /\d/, /\d/, '-', /\d/, /\d/]
};

const cpfCnpjMask = {
  guide: false,
  showMask: false,
  mask: [/[0-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
};

const idMask = {
  guide: false,
  showMask: false,
  mask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]
};

export { noMask, liquidationMask, numberMask, idMask, cnpjMask, cpfCnpjMask, cpfMask  };